// Clerk Integration Setup for Keyword OS
import { ClerkProvider } from '@clerk/clerk-react';

// Get the publishable key from environment variables
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key. Please add VITE_CLERK_PUBLISHABLE_KEY to your environment variables.");
}

// Export the publishable key for use in the app
export { PUBLISHABLE_KEY };

// Re-export Clerk components and hooks for easy importing
export {
  ClerkProvider,
  SignIn,
  SignUp,
  SignedIn,
  SignedOut,
  UserButton,
  useUser,
  useAuth,
  useClerk,
  RedirectToSignIn,
  SignInButton,
  SignUpButton,
  SignOutButton,
} from '@clerk/clerk-react';

// Export types
export type {
  UserResource,
  SessionResource,
  ClerkAPIError,
} from '@clerk/types';
